<template>
  <div>
    <el-table :data="datas" style="width: 100%" v-loading = "loading" show-summary>
      <el-table-column label="年份" prop="year" width="200"></el-table-column>
      <el-table-column label="学时" prop="hour"></el-table-column>
    </el-table>
  </div>
</template>

<script>

import { getUserHoursDetailApi } from '@/api/module/classHours/classHours'

export default {
  name: "HourDetailTableYears",
  data() {
    return {
      uid : null,
      datas : [],
      loading: false
    }
  },
  methods:{
    init(){
      if(this.loading){
        return;
      }

      this.loading = true;

      console.log("init current")    

      let data = {
        "uid" : this.uid
      }

      getUserHoursDetailApi(data)
        .then((r)=>{
          this.datas = r;
        })
        .finally(()=>{
          this.loading = false;
        })
    },

  },

  created(){
    let id = this.$route.query.id;
    this.uid = id;

    this.init();
  }
}


</script>



<style scoped>
.title {
  font-size: 14px;
  color: #303133;
  display: inline-block;
  padding-left: 10px;
  margin-right: 10px;
}
</style>